<template>
  <span
    :class="{
      spinner: true,
      'spinner--inline': inline,
      'spinner--small': small,
      'spinner--tiny': tiny,
      'spinner--white': white,
      'spinner--grey': grey,
    }"
  />
</template>

<script>
export default {
  name: 'BaseSpinner',

  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    tiny: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    grey: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
